import { render } from "./iconCalendar.vue?vue&type=template&id=16815a80"
import script from "./iconCalendar.vue?vue&type=script&lang=js"
export * from "./iconCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__